import React, {useState, useEffect} from "react";
import {Form, CloseButton} from 'react-bootstrap'
import "../../App.css" 
import "./Display.css";
import {Button} from 'rsuite'

export default function Display({display, setDisplay, nodeData}) {
    const [data, setData] = useState(null);
    const [displayWidth, setDisplayWidth] = useState("25vw")

    useEffect(() => {
        setData(null)
    }, [nodeData])

    useEffect(() => {
        let width = window.innerWidth
        if (width < 800) {
            setDisplayWidth("100vw")
        }
        console.log(width)
    }, [])

    return (<>
              <div className="display" style={{width: displayWidth}}>
            <CloseButton onClick={() => setDisplay(false)}></CloseButton>
            <div className="container-fluid">
                <div className="row">
                    <h2>{nodeData ? nodeData.name : null}</h2>
                </div>
                {nodeData &&
                <div className="row">
                    <div className="col-3">
                        <Button onClick={() => setData({direction: "From", datas: nodeData.incomings})} className="btn btn-primary"><img src="https://img.icons8.com/plasticine/512/incoming-data.png" width={30} height={30}/> <strong>Incoming</strong></Button>       
                    </div>
                    <div className="col-3">
                        <Button onClick={() => setData({direction: "To", datas: nodeData.outgoings})} className="btn btn-primary"><img src="https://img.icons8.com/plasticine/512/outgoing-data.png" width={30} height={30}/> <strong>Outgoing</strong></Button>        
                    </div>
                    <div className="col-3">
                        <Button onClick={() => setData({direction: "", datas: nodeData.neither})} className="btn btn-primary"><img src="https://img.icons8.com/fluency/512/replace.png" width={30} height={30}/> <strong>Neither</strong></Button>
                    </div>
                </div>
                }
               
                
                
                
                <div className="row">
             
                    {data ? data.datas.map((each) => {
                        return (<div className="col-6">
                                        <div className="info-card m-2">
                                            <div className="p-2">
                                                <h6>{each.name}</h6>
                                                <p><strong>{data.direction}</strong> {data.direction === "From" ? each.src_name : null}{data.direction === "To" ? each.dest_name : null}</p>
                                            </div>
                                        </div>
                                    </div>)
                    }) : null}
                </div>
            </div>
       
    
        </div>
        </>); 

        /*
   <div className="display">
            <CloseButton onClick={() => setDisplay(false)}></CloseButton>
            <div className="container-fluid">
                <div className="row">
                    <h2>{nodeData ? nodeData.name : null}</h2>
                </div>
                <button onClick={() => setData({direction: "From", datas: nodeData.incomings})} className="btn btn-primary">Incoming</button>       <button onClick={() => setData({direction: "To", datas: nodeData.outgoings})} className="btn btn-primary">Outgoing</button>        <button onClick={() => setData({direction: "", datas: nodeData.neither})} className="btn btn-primary">Neither</button>
                <div className="row">
             
                    {data ? data.datas.map((each) => {
                        return (<div className="col-6">
                                        <div className="info-card m-2">
                                            <div className="p-2">
                                                <h6>{each.name}</h6>
                                                <p><strong>{data.direction}</strong> {data.direction === "From" ? each.src_name : null}{data.direction === "To" ? each.dest_name : null}</p>
                                            </div>
                                        </div>
                                    </div>)
                    }) : null}
                </div>
            </div>
       
    
        </div>
        */
};